import React from "react";

export const HomeIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 11.5L12 4l8 7.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 10v9a1 1 0 0 0 1 1h3v-5.5h4V20h3a1 1 0 0 0 1-1v-9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ChatBubbleIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7A2.5 2.5 0 0 1 17.5 16H10l-4.5 3.5V16h-1A2.5 2.5 0 0 1 2 13.5v-7"
      strokeLinejoin="round"
    />
  </svg>
);

export const UsersIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="9" cy="8.5" r="3" />
    <path d="M2.8 19c1.1-2.9 3.4-4.5 6.2-4.5s5.1 1.6 6.2 4.5" strokeLinecap="round" />
    <path d="M15.5 5.3a3 3 0 0 1 0 5.9" strokeLinecap="round" />
    <path d="M17.5 14.8c2.3.5 4 1.9 4.9 4.2" strokeLinecap="round" />
  </svg>
);

export const BookIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M4 5.5c2-1 5-1 8 .5 3-1.5 6-1.5 8-.5v13c-2-1-5-1-8 .5-3-1.5-6-1.5-8-.5v-13z"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <path d="M12 6v13" />
  </svg>
);

export const BarChartIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 20V10M11 20V4M18 20v-7" strokeLinecap="round" />
    <path d="M3 20h18" strokeLinecap="round" />
  </svg>
);

export const GearIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="3" />
    <path
      d="M12 3.5v2M12 18.5v2M20.5 12h-2M5.5 12h-2M17.8 6.2l-1.4 1.4M7.6 16.4l-1.4 1.4M17.8 17.8l-1.4-1.4M7.6 7.6L6.2 6.2"
      strokeLinecap="round"
    />
  </svg>
);

export const PuzzleIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M9 4.5h3.5a1.5 1.5 0 0 1 1.5 1.5v2h1.5a2 2 0 0 1 0 4H14v2a1.5 1.5 0 0 1-1.5 1.5H10v1.5a2 2 0 1 1-4 0V15H4.5A1.5 1.5 0 0 1 3 13.5V10h1.5a2 2 0 0 0 0-4H3V4.5A1.5 1.5 0 0 1 4.5 3H7v1.5a2 2 0 1 0 2 0z"
      strokeLinejoin="round"
    />
  </svg>
);

export const CardIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="5.5" width="18" height="13" rx="2" />
    <path d="M3 9.5h18" />
    <path d="M6.5 14.5h4" strokeLinecap="round" />
  </svg>
);

export const SearchIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="11" cy="11" r="7" />
    <path d="M20.5 20.5L16 16" strokeLinecap="round" />
  </svg>
);

export const BellIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M6 10.5a6 6 0 0 1 12 0c0 4 1.5 5.5 1.5 5.5H4.5S6 14.5 6 10.5z" strokeLinejoin="round" strokeLinecap="round" />
    <path d="M10 19a2 2 0 0 0 4 0" strokeLinecap="round" />
  </svg>
);

export const ShareIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="18" cy="5.5" r="2.2" />
    <circle cx="6" cy="12" r="2.2" />
    <circle cx="18" cy="18.5" r="2.2" />
    <path d="M7.8 10.7l8.4-4.4M7.8 13.3l8.4 4.4" strokeLinecap="round" />
  </svg>
);

export const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M3.5 9.5h17M8 3v3.5M16 3v3.5" strokeLinecap="round" />
  </svg>
);

export const ExternalLinkIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M9 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 4h6v6M20 4l-9 9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const TrendUpIcon = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.4">
    <path d="M4 16l6-6 4 4 6-7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 7h5v5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const LightbulbIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M9 18h6M10 21h4" strokeLinecap="round" />
    <path
      d="M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"
      strokeLinejoin="round"
    />
  </svg>
);

export const LinkIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M9.5 14.5l5-5" strokeLinecap="round" />
    <path
      d="M11 6.5l1.5-1.5a3.5 3.5 0 0 1 5 5L16 11.5M13 17.5L11.5 19a3.5 3.5 0 0 1-5-5L8 12.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MinusIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4">
    <path d="M5 12h14" strokeLinecap="round" />
  </svg>
);
